import { render, staticRenderFns } from "./BindsAutocomplete.vue?vue&type=template&id=2d1ba0bc&"
import script from "./BindsAutocomplete.vue?vue&type=script&lang=js&"
export * from "./BindsAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./BindsAutocomplete.vue?vue&type=style&index=0&id=2d1ba0bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports